import { put, takeEvery } from "redux-saga/effects"
import {
  delPointsAxiosWithParams,
  getPointsAxiosWithParams,
  post,
  postPointsAxios,
} from "helpers/api_helper"
import { showSavingModal, hideSavingModal } from "../actions"
import {
  clearLeaderboardFailed,
  clearLeaderboardSuccess,
  getLeaderboardPointsFailed,
  getLeaderboardPointsSuccess,
  getLeaderboardUsersListFailed,
  getLeaderboardUsersListSuccess,
  getLeaderboardUsersPointsFailed,
  getLeaderboardUsersPointsSuccess,
  hideResetLeaderboardModal,
  updateLeaderboardPointsFailed,
  updateLeaderboardPointsSuccess,
} from "./actions"
import {
  CLEAR_LEADERBOARD,
  GET_LEADERBOARD_POINTS,
  GET_LEADERBOARD_USERS_LIST,
  GET_LEADERBOARD_USERS_POINTS,
  UPDATE_LEADERBOARD_POINTS,
} from "./actionTypes"

function* getLeaderboardPoints({ payload: params }) {
  try {
    const response = yield getPointsAxiosWithParams(`/event/${params}`)
    yield put(getLeaderboardPointsSuccess(response))
  } catch (error) {
    yield put(getLeaderboardPointsFailed(error))
  }
}

function* updateLeaderboardPoints({ payload: { eventId, points } }) {
  try {
    yield put(showSavingModal())
    const response = yield postPointsAxios(`/event/${eventId}`, {
      points,
    })
    yield put(updateLeaderboardPointsSuccess(response))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateLeaderboardPointsFailed(error))
  }
}

function* clearLeaderboard({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield delPointsAxiosWithParams(`/event/${params}`)
    yield put(clearLeaderboardSuccess(response))
    yield put(hideResetLeaderboardModal())
    yield put(hideSavingModal())
    yield
  } catch (error) {
    yield put(clearLeaderboardFailed(error))
  }
}

function* getLeaderboardUsersPoints({ payload: params }) {
  try {
    const response = yield getPointsAxiosWithParams("/users", { params })
    yield put(getLeaderboardUsersPointsSuccess(response))
  } catch (error) {
    yield put(getLeaderboardUsersPointsFailed(error))
  }
}

function* getLeaderboardUsersList({ payload: params }) {
  try {
    const response = yield post("/users", params)
    yield put(getLeaderboardUsersListSuccess(response))
  } catch (error) {
    yield put(getLeaderboardUsersListFailed(error))
  }
}

function* leaderboardSaga() {
  yield takeEvery(GET_LEADERBOARD_POINTS, getLeaderboardPoints)
  yield takeEvery(UPDATE_LEADERBOARD_POINTS, updateLeaderboardPoints)
  yield takeEvery(CLEAR_LEADERBOARD, clearLeaderboard)
  yield takeEvery(GET_LEADERBOARD_USERS_POINTS, getLeaderboardUsersPoints)
  yield takeEvery(GET_LEADERBOARD_USERS_LIST, getLeaderboardUsersList)
}

export default leaderboardSaga
